import { render, staticRenderFns } from "./CheckPromotions.vue?vue&type=template&id=d1e00550&scoped=true&"
import script from "./CheckPromotions.vue?vue&type=script&lang=js&"
export * from "./CheckPromotions.vue?vue&type=script&lang=js&"
import style0 from "./CheckPromotions.vue?vue&type=style&index=0&id=d1e00550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e00550",
  null
  
)

export default component.exports